export enum METHOD {
  spid = 'SPID',
  videoselfie = 'VIDEOSELFIE',
  mitek = 'MITEK'
}
